import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { 
  LayoutDashboard, 
  Map, 
  Package, 
  Wrench, 
  BarChart3, 
  Settings,
  Activity,
  LogOut,
  User
} from 'lucide-react';
import RoleSelector from './RoleSelector';
import LanguageSelector from './LanguageSelector';
import FindCleanBedButton from './FindCleanBedButton';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../contexts/AuthContext';
import { Button } from './ui/button';

const Navigation = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { user, profile, signOut } = useAuth();

  const navItems = [
    { path: '/', label: t('nav.dashboard'), icon: LayoutDashboard },
    { path: '/map', label: t('nav.map'), icon: Map },
    { path: '/assets', label: t('nav.assets'), icon: Package },
    { path: '/tickets', label: t('nav.tickets'), icon: Wrench },
    { path: '/analytics', label: t('nav.analytics'), icon: BarChart3 },
    { path: '/settings', label: t('nav.settings'), icon: Settings }
  ];

  const handleLogout = async () => {
    await signOut();
    navigate('/login');
  };

  const displayName = profile?.first_name 
    ? `${profile.first_name} ${profile.last_name || ''}`.trim()
    : user?.email?.split('@')[0] || 'User';

  return (
    <nav className="navigation-sidebar">
      <div className="nav-header">
        <Activity className="nav-logo-icon" size={32} strokeWidth={2.5} />
        <h1 className="nav-title">Kliniktrack</h1>
        <p className="nav-subtitle">Hospital Assets</p>
      </div>
      
      <div className="nav-menu">
        {navItems.map((item) => {
          const Icon = item.icon;
          const isActive = location.pathname === item.path;
          
          return (
            <Link
              key={item.path}
              to={item.path}
              className={`nav-item ${isActive ? 'active' : ''}`}
            >
              <Icon size={20} />
              <span className="nav-item-text">{item.label}</span>
            </Link>
          );
        })}
      </div>

      <div className="nav-footer">
        <div className="nav-quick-action">
          <FindCleanBedButton />
        </div>
        <LanguageSelector />
        <RoleSelector />
        
        {/* User Info & Logout */}
        <div className="nav-user-section">
          <div className="nav-user-info">
            <div className="nav-user-avatar">
              <User size={16} />
            </div>
            <div className="nav-user-details">
              <span className="nav-user-name">{displayName}</span>
              <span className="nav-user-role">{profile?.role || 'viewer'}</span>
            </div>
          </div>
          <Button 
            variant="ghost" 
            size="sm" 
            onClick={handleLogout}
            className="nav-logout-btn"
            title={t('auth.logout')}
          >
            <LogOut size={18} />
          </Button>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
